module.exports = __webpack_public_path__ + "media/23.3b05ec28.wav";